import {css} from '@yandex-delivery/blocks/theme/css'

export const body = css`
  background: transparent;
`
